import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const SITE_URL = "http://cqxbygc.cn";

export default function AboutPage() {
  return (
    <>
      <title>关于我们 - 91吃瓜社区</title>
      <meta
        name="description"
        content="了解91吃瓜社区的品牌故事、发展历程与核心理念。全网最真的瓜，每日不打烊更新，为吃瓜群众提供最速爆料入口。"
      />
      <link rel="canonical" href="/about" />

      {/* Organization Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "91吃瓜社区",
          url: SITE_URL,
          logo: `${SITE_URL}/vite.svg`,
          description:
            "91吃瓜社区是全网领先的娱乐八卦资讯平台，每日更新最新爆料与热点话题。",
          sameAs: [],
        })}
      </script>

      {/* WebPage Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "关于我们 - 91吃瓜社区",
          description:
            "了解91吃瓜社区的品牌故事、发展历程与核心理念。",
          url: `${SITE_URL}/about`,
          isPartOf: {
            "@type": "WebSite",
            name: "91吃瓜社区",
            url: SITE_URL,
          },
        })}
      </script>

      {/* Breadcrumb Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "首页",
              item: SITE_URL,
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "关于我们",
              item: `${SITE_URL}/about`,
            },
          ],
        })}
      </script>

      <Navbar />

      <main className="pt-16 md:pt-20">
        {/* Breadcrumb */}
        <div className="w-full px-4 md:px-6 lg:px-8 py-3 md:py-4">
          <nav aria-label="面包屑导航">
            <ol className="flex items-center gap-2 text-sm text-foreground-500">
              <li>
                <Link to="/" className="hover:text-primary-500 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line" />
                </span>
              </li>
              <li className="text-foreground-800 font-medium">关于我们</li>
            </ol>
          </nav>
        </div>

        {/* Hero */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-8 md:py-12">
          <div className="text-center max-w-3xl mx-auto">
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-4">
              品牌故事
            </span>
            <h1
              className="text-3xl md:text-4xl font-bold text-foreground-950 leading-tight"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              关于 <span className="text-primary-500">91吃瓜</span>
            </h1>
            <p className="mt-4 text-base md:text-lg text-foreground-600 leading-relaxed">
              全网最真的瓜，不打烊更新。我们致力于为每一位吃瓜群众提供最速、最全的热点爆料入口。
            </p>
          </div>
        </section>

        {/* Brand Story */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-8 md:py-12 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div>
                <h2
                  className="text-xl md:text-2xl font-bold text-foreground-950 mb-4"
                  style={{ fontFamily: "var(--font-heading)" }}
                >
                  我们的故事
                </h2>
                <div className="space-y-3 text-sm md:text-base text-foreground-700 leading-relaxed">
                  <p>
                    91吃瓜社区诞生于对信息透明度的追求。在信息爆炸的时代，我们希望能够为普通网友提供一个快速、便捷地获取真实热点话题的平台。
                  </p>
                  <p>
                    从最初的个人博客到如今覆盖全网热点的资讯社区，91吃瓜始终坚持以真实、及时、有趣为核心价值观，让每一位吃瓜群众都能在这里找到属于自己的快乐。
                  </p>
                  <p>
                    我们不生产瓜，我们只是瓜的搬运工。所有内容均来源于网络公开信息整理，旨在为用户提供娱乐参考。
                  </p>
                </div>
              </div>
              <div className="rounded-xl overflow-hidden aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20digital%20newsroom%20workspace%20concept%2C%20multiple%20screens%20showing%20social%20media%20feeds%2C%20warm%20amber%20and%20soft%20red%20ambient%20lighting%2C%20dark%20moody%20atmosphere%2C%20editorial%20photography%20style%2C%20creative%20workspace&width=800&height=600&seq=about-story&orientation=landscape"
                  alt="91吃瓜社区工作场景"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2
                className="text-xl md:text-2xl font-bold text-foreground-950"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                社区数据
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                用数字见证91吃瓜社区的成长
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {[
                { number: "500+", label: "原创文章" },
                { number: "200万+", label: "月阅读量" },
                { number: "50万+", label: "活跃用户" },
                { number: "99%", label: "用户满意度" },
              ].map((stat) => (
                <div
                  key={stat.label}
                  className="text-center p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60"
                >
                  <p className="text-2xl md:text-3xl font-bold text-primary-600">
                    {stat.number}
                  </p>
                  <p className="mt-1.5 text-sm text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2
                className="text-xl md:text-2xl font-bold text-foreground-950"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                为什么选择91吃瓜
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                四大核心优势，打造极致吃瓜体验
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {[
                {
                  icon: "ri-flashlight-line",
                  title: "极速更新",
                  desc: "热点事件发生后第一时间跟进报道，让你永远比别人早知道。",
                },
                {
                  icon: "ri-shield-check-line",
                  title: "真实可靠",
                  desc: "多源交叉验证，力求还原事件真相，拒绝虚假爆料。",
                },
                {
                  icon: "ri-layout-grid-line",
                  title: "分类清晰",
                  desc: "六大热门分类覆盖全网热点，一键找到你感兴趣的瓜。",
                },
                {
                  icon: "ri-smartphone-line",
                  title: "全端适配",
                  desc: "完美适配手机、平板、电脑，随时随地快乐吃瓜。",
                },
              ].map((feature) => (
                <div
                  key={feature.title}
                  className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60"
                >
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3">
                    <i className={`${feature.icon} text-lg`} />
                  </span>
                  <h3 className="text-base font-semibold text-foreground-950 mb-1.5">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-3">
                常见问题
              </span>
              <h2
                className="text-xl md:text-2xl font-bold text-foreground-950"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                FAQ
              </h2>
            </div>
            <div className="space-y-3">
              {[
                {
                  q: "91吃瓜的内容来源是什么？",
                  a: "我们的内容来源于网络公开信息、社交媒体热点、行业爆料等渠道的整理与汇总。所有文章均注明来源，仅供娱乐参考。",
                },
                {
                  q: "网站更新频率是怎样的？",
                  a: "91吃瓜社区实行不打烊更新策略，热点事件发生后通常会在1-2小时内发布相关报道，确保用户能够第一时间获取最新信息。",
                },
                {
                  q: "如何联系91吃瓜团队？",
                  a: "您可以通过页面底部的邮箱联系我们，我们会在24小时内回复。如果您有爆料线索，也欢迎通过邮件发送给我们。",
                },
                {
                  q: "网站内容是否收费？",
                  a: "91吃瓜社区所有内容完全免费，我们不会向用户收取任何费用。您可以自由浏览、分享所有文章。",
                },
                {
                  q: "如何投稿或爆料？",
                  a: "欢迎广大网友提供有价值的爆料线索。请将详细内容和相关证据发送至我们的官方邮箱，编辑团队会认真审核每一条线索。",
                },
              ].map((faq, i) => (
                <details
                  key={i}
                  className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
                >
                  <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                    <h3 className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                      {faq.q}
                    </h3>
                    <span className="w-5 h-5 flex items-center justify-center shrink-0 text-foreground-500 group-open:rotate-180 transition-transform">
                      <i className="ri-arrow-down-s-line" />
                    </span>
                  </summary>
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* FAQPage Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "91吃瓜的内容来源是什么？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "我们的内容来源于网络公开信息、社交媒体热点、行业爆料等渠道的整理与汇总。所有文章均注明来源，仅供娱乐参考。",
                },
              },
              {
                "@type": "Question",
                name: "网站更新频率是怎样的？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "91吃瓜社区实行不打烊更新策略，热点事件发生后通常会在1-2小时内发布相关报道，确保用户能够第一时间获取最新信息。",
                },
              },
              {
                "@type": "Question",
                name: "如何联系91吃瓜团队？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "您可以通过页面底部的邮箱联系我们，我们会在24小时内回复。如果您有爆料线索，也欢迎通过邮件发送给我们。",
                },
              },
              {
                "@type": "Question",
                name: "网站内容是否收费？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "91吃瓜社区所有内容完全免费，我们不会向用户收取任何费用。您可以自由浏览、分享所有文章。",
                },
              },
              {
                "@type": "Question",
                name: "如何投稿或爆料？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "欢迎广大网友提供有价值的爆料线索。请将详细内容和相关证据发送至我们的官方邮箱，编辑团队会认真审核每一条线索。",
                },
              },
            ],
          })}
        </script>

        {/* Contact CTA */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 bg-background-100">
          <div className="max-w-2xl mx-auto text-center">
            <h2
              className="text-xl md:text-2xl font-bold text-foreground-950"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              联系我们
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              如果您有任何问题、建议或爆料线索，欢迎随时与我们联系
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="mailto:hello@cqxbygc.cn"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line" />
                </span>
                hello@cqxbygc.cn
              </a>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-200 text-foreground-800 text-sm font-medium hover:bg-background-300 transition-colors whitespace-nowrap"
              >
                返回首页
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
